// Centralized admin API helper
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const getToken = () => localStorage.getItem('admin_token');

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminApi = axios.create({ baseURL: `${API_BASE}/admin` });
adminApi.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...authHeaders() };
  return config;
});

export const contentApi = axios.create({ baseURL: `${API_BASE}/content` });

export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await adminApi.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  // Normalize to absolute URL
  return `${BACKEND_URL}${res.data.file_url}`;
};
